import classNames from 'classnames';
import { t } from 'ttag';

import { GenderEnum } from '@models';
import { Alert } from '@ui/Alert';

import s from './ProductDetailsAlerts.sss';

interface Seller {
  id: number,
  gender?: GenderEnum | null,
  hasRecentActivity: boolean,
  fraudWarning: boolean,
}

interface Product {
  id: number,
  seller: Seller,
}

interface Props {
  className?: string,
  product: Product,
}

export const ProductDetailsAlerts: React.FC<Props> = ({
  className,
  product,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      {!product.seller.hasRecentActivity && (
        <Alert
          className={s.alert}
          theme='warning'
        >
          {t`Продавець цієї речі`}
          &nbsp;
          {product.seller.gender === GenderEnum.GenderMale ? t`був` : t`була`}
          &nbsp;
          {t`на Шафі більше 30 днів тому`}
        </Alert>
      )}

      {product.seller.fraudWarning && (
        <Alert
          className={s.alert}
          theme='warning'
        >
          {t`Увага! За даним продавцем йде розгляд.`}
        </Alert>
      )}
    </div>
  );
};
